import { render, staticRenderFns } from "./settings-employee-search-oauth-integrations.vue?vue&type=template&id=6a5b548c&scoped=true&"
import script from "./settings-employee-search-oauth-integrations.vue?vue&type=script&lang=js&"
export * from "./settings-employee-search-oauth-integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b548c",
  null
  
)

export default component.exports